import { CustomEdge } from './customEdge'

export const EDGE_TYPE = {
  customEdge: CustomEdge,
}
